export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628] via-[#1E3A5F] to-[#0A1628]"></div>
      
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/d819f4f5ff35555f11e91a4e79436e7e.jpg')] bg-cover bg-center opacity-20"></div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="absolute bottom-20 right-20 opacity-30">
        <div className="w-64 h-64 relative">
          <svg className="w-full h-full" viewBox="0 0 200 200" fill="none">
            <circle cx="100" cy="100" r="80" stroke="#00D9FF" strokeWidth="1" opacity="0.3"/>
            <circle cx="100" cy="100" r="60" stroke="#00D9FF" strokeWidth="1" opacity="0.5"/>
            <circle cx="100" cy="100" r="40" stroke="#00D9FF" strokeWidth="1" opacity="0.7"/>
            <line x1="100" y1="20" x2="100" y2="180" stroke="#00D9FF" strokeWidth="1" opacity="0.3"/>
            <line x1="20" y1="100" x2="180" y2="100" stroke="#00D9FF" strokeWidth="1" opacity="0.3"/>
          </svg>
        </div>
      </div>

      <div className="absolute top-32 right-32 animate-float">
        <div className="w-24 h-24 bg-[#00D9FF]/10 rounded-full flex items-center justify-center backdrop-blur-sm">
          <i className="ri-shield-check-line text-4xl text-[#00D9FF]"></i>
        </div>
      </div>

      <div className="relative z-10 text-center px-8 max-w-5xl mx-auto">
        <div className="inline-block mb-6 px-6 py-2 border border-[#00D9FF] rounded-full bg-[#00D9FF]/10 backdrop-blur-sm">
          <span className="text-white text-sm font-medium whitespace-nowrap">Secure VPN Solution</span>
        </div>

        <h1 className="text-7xl font-bold text-white mb-6 leading-tight">
          Protect Your Digital<br />Privacy Everywhere
        </h1>

        <p className="text-[#8B9DB5] text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
          Enterprise-grade encryption for your online security and freedom
        </p>

        <button
          onClick={scrollToContact}
          className="inline-flex items-center gap-3 bg-[#00D9FF] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#00C4E6] transition-all duration-300 shadow-2xl hover:shadow-[#00D9FF]/50 hover:scale-105 whitespace-nowrap"
        >
          Start Secure Browsing
          <i className="ri-arrow-right-line text-xl"></i>
        </button>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
